import React from 'react'

import styled from 'styled-components'

import {H5, P} from '@festi/common/components/typography'
import {SearchType} from '@festi/common/utils/tagmanager'

import {HitsContainer} from './QuickSearchHits'
import useAlgoliaSearch from 'src/components/search/redesign/utilites/useAlgoliaSearch'

const Column = styled.div`
  padding: 20px;
`

const HistoryItem = styled.div`
  padding: 4px 0;
  cursor: pointer;
`

interface HitsProps {
  handleSubmitQuery: (query: string, type: SearchType) => void
}

export default function SearchHistory({handleSubmitQuery}: HitsProps) {
  const {searchHistory} = useAlgoliaSearch()

  if (!searchHistory.length) return null

  return (
    <HitsContainer>
      <Column>
        <H5 withGutter>Síðustu leitir</H5>

        {searchHistory.map((item: string, index: number) => (
          <HistoryItem
            key={index}
            tabIndex={0}
            onClick={() => handleSubmitQuery(item, 'search_history')}
          >
            <P>{item}</P>
          </HistoryItem>
        ))}
      </Column>
    </HitsContainer>
  )
}
